
import Vue, { PropType } from 'vue';
import { mergeData } from 'vue-functional-data-merge';

import BaseIcon from '../BaseIcon/BaseIcon.vue';

const POSITION = ['left', 'right'] as const;

export default Vue.extend({
  functional: true,
  props: {
    category: {
      type: String,
      default: 'utility',
    },
    size: {
      type: String,
      default: 'x-small',
    },
    colorVariant: {
      type: String,
      default: 'default',
    },
    position: {
      type: String as PropType<typeof POSITION[number]>,
      default: 'right',
    },
  },
  render(h, { props, data }) {
    return h(
      BaseIcon,
      mergeData(data, {
        props: {
          category: props.category,
          size: props.size,
          colorVariant: props.colorVariant,
        },
        class:
          props.position === 'right'
            ? 'slds-m-left_small'
            : 'slds-m-right_x-small',
        staticClass: 'slds-icon',
      })
    );
  },
});
